var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DETAIL-ITEM"},[_c('label',{staticClass:"DETAIL-ITEM-LABEL"},[_vm._t("label",function(){return [_vm._v("\n      "+_vm._s(_vm.itemLabel)+"\n    ")]})],2),_c('div',{staticClass:"DETAIL-ITEM-VALUE",attrs:{"selenium":_vm.itemSelenium}},[_vm._t("value",function(){return [_vm._v("\n      "+_vm._s(_vm.itemValue)+"\n    ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }